import { marketingQueryKeys as e } from "./marketingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { marketingApi as n } from "@maat/api-main";
//#region src/marketing/useMarketingAssetsQuery.ts
var r = (r, i) => t({
	queryKey: e.active(r),
	queryFn: () => n.getActiveAssets(r),
	enabled: i?.enabled
});
//#endregion
export { r as useMarketingAssetsQuery };
